var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeb3StatusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_461_13342)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint1_linear_461_13342)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4675 21.8471C21.8886 21.8471 23.0406 20.695 23.0406 19.2739C23.0406 17.8528 21.8886 16.7008 20.4675 16.7008C19.0463 16.7008 17.8943 17.8528 17.8943 19.2739C17.8943 20.695 19.0463 21.8471 20.4675 21.8471ZM23.8951 19.2739C23.8951 21.167 22.3605 22.7016 20.4675 22.7016C18.5744 22.7016 17.0398 21.167 17.0398 19.2739C17.0398 17.3809 18.5744 15.8463 20.4675 15.8463C22.3605 15.8463 23.8951 17.3809 23.8951 19.2739Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3567 21.0465C18.5275 21.2562 18.4959 21.5646 18.2862 21.7354C16.5064 23.1852 14.6528 24.197 13.0141 24.639C11.3986 25.0748 9.85575 24.9859 8.87938 24.0096C7.79541 22.9256 7.8022 21.1472 8.41946 19.3175C8.5059 19.0612 8.78371 18.9236 9.03995 19.01C9.2962 19.0964 9.43385 19.3743 9.34741 19.6305C8.76155 21.3672 8.90083 22.646 9.57187 23.3171C10.1745 23.9197 11.2649 24.0965 12.7591 23.6934C14.2301 23.2966 15.9626 22.365 17.6678 20.9761C17.8774 20.8053 18.1859 20.8368 18.3567 21.0465Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9399 11.4591C14.7756 11.2443 14.8165 10.937 15.0313 10.7727C16.739 9.46628 18.4935 8.56687 20.0419 8.19349C21.5719 7.82458 23.0231 7.94651 23.9559 8.87931C25.0399 9.96327 25.0331 11.7417 24.4158 13.5714C24.3294 13.8277 24.0516 13.9653 23.7953 13.8789C23.5391 13.7924 23.4015 13.5146 23.4879 13.2584C24.0737 11.5217 23.9345 10.2428 23.2634 9.5718C22.6881 8.9965 21.6696 8.80843 20.2715 9.14554C18.8919 9.47819 17.26 10.3008 15.6263 11.5505C15.4115 11.7148 15.1042 11.6739 14.9399 11.4591Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5513 13.3982C16.5513 15.2912 15.0167 16.8258 13.1237 16.8258C11.2307 16.8258 9.69604 15.2912 9.69604 13.3982C9.69604 11.5051 11.2307 9.97052 13.1237 9.97052C15.0167 9.97052 16.5513 11.5051 16.5513 13.3982ZM12.7808 11.6841H13.4663V13.055H14.8369V13.7406H13.4663V15.1117H12.7808V13.7406H11.4092V13.055H12.7808V11.6841Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6921 19.5679V18.8824H19.2438V19.5679H21.6921Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_461_13342",
    x1: 31.4,
    y1: -0.00000308087,
    x2: -1.93422,
    y2: 6.13602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#31B047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_461_13342",
    x1: 16,
    y1: 32,
    x2: 16,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208333,
    stopColor: "#31B047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0CB0B",
    stopOpacity: 0.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb3StatusIcon);
export default __webpack_public_path__ + "static/media/web3status_icon.0d15e5ff.svg";
export { ForwardRef as ReactComponent };